import { Account, Client, Locale, Teams } from 'appwrite';

const endpoint =
    import.meta.env.VITE_APPWRITE_ENDPOINT ||
    import.meta.env.APPWRITE_ENDPOINT ||
    'https://fra.cloud.appwrite.io/v1';

const projectId =
    import.meta.env.VITE_APPWRITE_PROJECT_ID ||
    import.meta.env.APPWRITE_PROJECT_ID ||
    '';

export const client = new Client()
    .setEndpoint(endpoint)
    .setProject(projectId)
    // Hebrew labels for country / continent names from Locale.
    .setLocale('he');

export const account = new Account(client);

export const locale = new Locale(client);

/** One-off client so invite auth does not leak onto the shared Locale client. */
export function createStaffInviteTeamsClient(input: {
    session: string;
    endpoint?: string;
    projectId?: string;
}) {
    const inviteClient = new Client()
        .setEndpoint(input.endpoint || endpoint)
        .setProject(input.projectId || projectId);

    if (input.session.startsWith('jwt:')) {
        inviteClient.setJWT(input.session.slice(4));
    } else {
        inviteClient.setSession(input.session);
    }

    return new Teams(inviteClient);
}
